const translations = {
    es: {
        deviceparams: "Parámetros del dispositivo",
        devicemeasure: "Medida",
        devicetotal: "Total",
        devicegroup: "Grupo",
        deviceddparams: "Parámetros DD",
        devicenfc_report: "Informe NFC",
    },
    en: {
        deviceparams: "Device Parameters",
        devicemeasure: "Measure",
        devicetotal: "Total",
        devicegroup: "Group",
        deviceddparams: "DD Parameters",
        devicenfc_report: "NFC Report",
    },
};
export default translations;
